export default "{\n    \"label\": \"Miembro del equipo\",\n    \"label_plural\": \"{{count}} miembros del equipo\"\n}\n"